<template>
  <label class="radio-label" :for="identifier" :class="{ disabled: disabled }">
    <input
      :id="identifier"
      type="radio"
      class="radio iw-visuallyhidden"
      :name="groupName"
      :value="payload || label"
      :checked="isChecked"
      :disabled="disabled"
      @change="change"
    />
    <span class="custom-radio checked"></span>
    <span class="custom-radio unchecked"></span>
    <img v-if="image" class="radio-label__image" :src="require('@/assets/images/' + image + '')" alt="" />
    <slot></slot>
    <div v-if="label" class="iw-hyperlink radio-label__title" :class="{ imageLabelOffset: image }">
      {{ label }}
    </div>
  </label>
</template>

<script>
export default {
  name: "AppRadioButton",
  props: {
    groupName: String,
    label: String,
    modelValue: String,
    payload: [String, Number, Boolean],
    disabled: Boolean,
    image: String,
    id: String
  },
  methods: {
    change: function (event) {
      this.$emit("update:modelValue", event.target.value);
      this.$emit("onChangeHandler", event);
    }
  },
  computed: {
    identifier() {
      return this.id ?? `${this.groupName} - ${this.label || this.payload}`;
    },
    isChecked() {
      if (this.disabled) {
        return false;
      }
      return this.modelValue === String(this.payload);
    }
  }
};
</script>

<style scoped lang="scss">
.radio-label {
  display: flex;
  align-items: center;
  word-break: break-word;
  cursor: pointer;

  &__title {
    height: 13px;
    margin-left: 36px;
    margin-right: 25px;
    color: $group-3-color-2;
    margin-top: 0px;
    margin-bottom: 0px;
    font-style: normal;
    line-height: 1.2;
  }
  &__image {
    background-color: #fff;
    max-height: 36px;
    margin-left: 36px;
  }
}

body.user-is-tabbing .radio-label input:focus ~ .custom-radio {
  outline: 2px solid $group-2-color-3 !important; /* for non-webkit browsers */
  outline: 2px auto -webkit-focus-ring-color !important;
}

.imageLabelOffset {
  margin-left: 8px;
}

.disabled {
  opacity: 0.4;
  cursor: initial;
}

.checked {
  display: none;
  background-color: $group-3-color-4;
}

.readOnly {
  display: none;
  background-color: $group-3-color-3;
}

.unchecked {
  display: inline-block;
  background-color: transparent;
}

.checked {
  position: absolute;
  min-width: 12px;
  height: 12px;
  margin-right: 5px;
  margin-left: 5px;
  border-radius: 100%;
}

.unchecked {
  position: absolute;
  min-width: 12px;
  height: 12px;
  margin-right: 5px;
  margin-left: 5px;
  border-radius: 100%;

  &::after {
    content: "";
    position: absolute;
    top: -7px;
    left: -7px;
    width: 24px;
    height: 24px;
    border: 1px solid $border-color;
    border-radius: 100%;
  }
}

.radio:checked + .checked {
  display: inline-block;
}
</style>
